import React, { createContext, memo, useContext, useState, useRef, useEffect, Fragment, useCallback, useMemo } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Box, Flex } from '@rebass/grid';
import { parseDate, hourMinuteMeridian, dayOfWeekLongFormatter, monthLongFormatter, dayOfMonthFormatter } from '@amtrav/dates';
import { Button, Avatar, ClickableGraphic } from '@amtrav/view-components';
import { IconCheckLine, IconCheckDouble, IconChatRound, IconSmile } from '@amtrav/icons';
import { getThemeProp, MatchMedia, ZINDEX } from '@amtrav/themes';
import { getTokenValue, THEME_TOKENS } from '@amtrav/theme-system';
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
import { Popover } from 'react-tiny-popover';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var ChatUserContext = createContext({
    id: '0',
    clientName: 'default',
    avatarUrl: '',
    online: false,
    paused: false,
    tags: '',
    numberOfSessions: 0,
    created: 'never',
    updated: 'never',
    isAgent: false,
    deleted: false,
    nameNum: 1235,
    aNum: 5213,
    divNum: 'none',
    email: 'nope',
    vip: false,
    companyName: '',
    userRole: '',
    jobTitle: '',
    maxNumberOfSessions: 1,
});

var BubbleDiv = styled(Box)(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 1.2;\n  border-radius: 10px;\n  padding: 8px 10px;\n  word-break: break-word;\n"], ["\n  font-size: 14px;\n  line-height: 1.2;\n  border-radius: 10px;\n  padding: 8px 10px;\n  word-break: break-word;\n"])));
var ThemBubble = styled(BubbleDiv)(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  border-bottom-left-radius: ", ";\n  border-top-left-radius: ", ";\n"], ["\n  background-color: ", ";\n  color: ", ";\n  border-bottom-left-radius: ", ";\n  border-top-left-radius: ", ";\n"])), getTokenValue(THEME_TOKENS.base.color.infoBackground), getTokenValue(THEME_TOKENS.base.color.primaryText), function (_a) {
    var isEnd = _a.isEnd;
    return (isEnd ? '10px' : '0');
}, function (_a) {
    var isStart = _a.isStart;
    return (isStart ? '10px' : '0');
});
var DoubleAgentBubble = styled(BubbleDiv)(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  background-color: ", ";\n  color: black;\n  border-bottom-right-radius: ", ";\n  border-top-right-radius: ", ";\n  text-align: right;\n"], ["\n  background-color: ", ";\n  color: black;\n  border-bottom-right-radius: ", ";\n  border-top-right-radius: ", ";\n  text-align: right;\n"])), getThemeProp('global.light--color'), function (_a) {
    var isEnd = _a.isEnd;
    return (isEnd ? '10px' : '0');
}, function (_a) {
    var isStart = _a.isStart;
    return (isStart ? '10px' : '0');
});
var ContentRegion = styled(Box)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var MeBubble = styled(BubbleDiv)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  /* TODO: needs to be replaced with @amtrav/themes */\n  background-color: #e5e5e5;\n  color: ", ";\n  border-bottom-right-radius: ", ";\n  border-top-right-radius: ", ";\n  text-align: right;\n"], ["\n  /* TODO: needs to be replaced with @amtrav/themes */\n  background-color: #e5e5e5;\n  color: ", ";\n  border-bottom-right-radius: ", ";\n  border-top-right-radius: ", ";\n  text-align: right;\n"])), getTokenValue(THEME_TOKENS.base.color.primaryText), function (_a) {
    var isEnd = _a.isEnd;
    return (isEnd ? '10px' : '0');
}, function (_a) {
    var isStart = _a.isStart;
    return (isStart ? '10px' : '0');
});
var Bubble = function (_a) {
    var content = _a.content, me = _a.me, doubleAgent = _a.doubleAgent, start = _a.start, end = _a.end;
    var ThisBubble = ThemBubble;
    if (me) {
        ThisBubble = MeBubble;
    }
    else if (doubleAgent) {
        ThisBubble = DoubleAgentBubble;
    }
    return (React.createElement(ThisBubble, { isStart: start, isEnd: end },
        React.createElement(ContentRegion, null, content)));
};
var templateObject_1$b, templateObject_2$5, templateObject_3$3, templateObject_4$3, templateObject_5$3;

var SYSTEM_SENDER_ID = 'system';
var AvatarSpace = styled(Flex)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  flex: 0 0 auto;\n  justify-content: center;\n  height: 36px;\n  width: 52px;\n"], ["\n  flex: 0 0 auto;\n  justify-content: center;\n  height: 36px;\n  width: 52px;\n"])));
styled(Flex)(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  flex: 0 10 auto;\n  justify-content: center;\n  height: 36px;\n  width: 40px;\n"], ["\n  flex: 0 10 auto;\n  justify-content: center;\n  height: 36px;\n  width: 40px;\n"])));
var NoAvatarSpace = styled(Flex)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  height: 36px;\n  width: 8px;\n"], ["\n  flex: 0 0 auto;\n  height: 36px;\n  width: 8px;\n"])));
var AvatarNameWrapper = styled(Flex)(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  flex-direction: column;\n  width: 52px;\n  height: 52px;\n  align-items: center;\n"], ["\n  flex-direction: column;\n  width: 52px;\n  height: 52px;\n  align-items: center;\n"])));
var AvatarFirstName = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  width: 48px;\n  text-align: center;\n  color: black;\n  font-size: 11px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-top: 4px;\n"], ["\n  width: 48px;\n  text-align: center;\n  color: black;\n  font-size: 11px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-top: 4px;\n"])));
var SelectOptionWrapper = styled(Box)(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  margin: 5px;\n"], ["\n  margin: 5px;\n"])));
var SystemMessageStyled = styled(Flex)(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  width: 100%;\n  justify-content: center;\n  font-size: 13px;\n  color: black;\n  font-weight: 600;\n  padding: 8px;\n"], ["\n  width: 100%;\n  justify-content: center;\n  font-size: 13px;\n  color: black;\n  font-weight: 600;\n  padding: 8px;\n"])));
var ModifyPayloadWrapper = styled(Flex)(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  margin: 5px;\n"], ["\n  margin: 5px;\n"])));
var showMe = false;
// Set up a helper function for replacing simple link text and markdown links with actual links
// The matcher has two parts, the markdown matcher, and the plain link matcher.
//
// The plain matcher is pretty basic, and urls *must* include the http(s)://
//
// The Markdown matcher will match text of the form [Display Text](url)
var LINK_FINDER = /((?:\[[\w\s\d]+\]\((?:\/|https?:\/\/)\S+?\))|(?:https?:\/\/\S+))/gi;
var MARKDOWN_LINK = /(\[([\w\s\d]+)\]\(((?:\/|https?:\/\/)\S+?)\))/i;
var PLAIN_LINK = /(https?:\/\/\S+)/i;
var linkify = function (message, me) {
    var linkColor = {
        color: me ? '#fff0bb' : null,
    };
    var bits = message.split(LINK_FINDER);
    return bits.map(function (bit) {
        var potentialMarkdown = bit.match(MARKDOWN_LINK);
        if (potentialMarkdown)
            return (React.createElement("a", { href: potentialMarkdown[3], target: "_blank", style: linkColor, rel: "noreferrer" }, potentialMarkdown[2]));
        var potentialLink = bit.match(PLAIN_LINK);
        if (potentialLink)
            return (React.createElement("a", { href: bit, target: "_blank", style: linkColor, rel: "noreferrer" }, bit));
        return bit;
    });
};
var MessageRow = memo(function (_a) {
    var message = _a.message, messages = _a.messages, onSend = _a.onSend, sender = _a.sender, rest = __rest(_a, ["message", "messages", "onSend", "sender"]);
    var user = useContext(ChatUserContext);
    var doubleAgent = sender && sender.isAgent && user && user.isAgent && sender.id !== user.id;
    var itMe = message.senderUserId === user.id; // Agents see other agent's messages formatted like their own
    switch (message.payload.type) {
        case 'text':
            if (message.senderUserId === SYSTEM_SENDER_ID) {
                return React.createElement(SystemMessageRow, __assign({ payload: message.payload, sender: sender }, rest));
            }
            return (React.createElement(TextMessageRow, __assign({ payload: message.payload, itMe: itMe, doubleAgent: doubleAgent, delivered: message.delivered, seen: message.seen, sender: sender }, rest)));
        case 'select':
            return (React.createElement(SelectMessageRow, __assign({ payload: message.payload, itMe: itMe, doubleAgent: doubleAgent, onSend: onSend, messages: messages, sender: sender }, rest)));
        case 'html':
            return (React.createElement(HTMLMessageRow, __assign({ payload: message.payload, itMe: itMe, doubleAgent: doubleAgent, delivered: message.delivered, seen: message.seen, sender: sender }, rest)));
        case 'modify-trip':
            return (React.createElement(ModifyTripMessageRow, __assign({ payload: message.payload, itMe: itMe, doubleAgent: doubleAgent, sender: sender }, rest)));
        default:
            return null;
    }
});
var SeenCheckContainer = styled.span(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  align-self: flex-end;\n  color: #90c2ff;\n  position: relative;\n  right: -4px;\n  margin-left: 4px;\n  height: 16px;\n  font-size: 16px;\n"], ["\n  align-self: flex-end;\n  color: #90c2ff;\n  position: relative;\n  right: -4px;\n  margin-left: 4px;\n  height: 16px;\n  font-size: 16px;\n"])));
var DeliveredIcon = styled(IconCheckLine)(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  color: #9a9a9a;\n"], ["\n  color: #9a9a9a;\n"])));
var LinkTextBox = styled(Box)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  white-space: pre-wrap;\n  text-align: left;\n"], ["\n  white-space: pre-wrap;\n  text-align: left;\n"])));
// fix for width issue in IE
var BubbleCont = styled(Box)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    width: 84%;\n  }\n"], ["\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    width: 84%;\n  }\n"])));
var AvatarBubble = function (_a) {
    var children = _a.children, sender = _a.sender, botName = _a.botName, itMe = _a.itMe, doubleAgent = _a.doubleAgent, startBlock = _a.startBlock, endBlock = _a.endBlock, delivered = _a.delivered, seen = _a.seen, afterBubble = _a.afterBubble;
    var initials = sender === null || sender === void 0 ? void 0 : sender.clientName.toUpperCase().split(' ').map(function (word) { return word.charAt(0); }).join('');
    var firstName = sender === null || sender === void 0 ? void 0 : sender.clientName.split(' ').shift();
    var displayName = (sender === null || sender === void 0 ? void 0 : sender.id) === 'chatbot' ? botName : firstName;
    var rightSide = itMe || doubleAgent;
    return (React.createElement(Flex, { m: "2px 0", p: "1px", flexDirection: rightSide ? 'row-reverse' : 'row' },
        !itMe || showMe ? (React.createElement(AvatarSpace, null, startBlock ? (React.createElement(AvatarNameWrapper, null,
            React.createElement(Avatar, { imgUrl: sender === null || sender === void 0 ? void 0 : sender.avatarUrl, initials: initials }),
            React.createElement(AvatarFirstName, null, displayName))) : null)) : (React.createElement(NoAvatarSpace, null)),
        React.createElement(BubbleCont, null,
            React.createElement(Bubble, { doubleAgent: doubleAgent, content: React.createElement(Flex, null,
                    children,
                    React.createElement(SeenCheckContainer, null, itMe && delivered && (seen ? React.createElement(IconCheckDouble, null) : React.createElement(DeliveredIcon, null)))), me: itMe, start: startBlock, end: endBlock }),
            afterBubble),
        React.createElement(NoAvatarSpace, null)));
};
var TextMessageRow = memo(function (_a) {
    var payload = _a.payload, itMe = _a.itMe, rest = __rest(_a, ["payload", "itMe"]);
    return (React.createElement(AvatarBubble, __assign({ itMe: itMe }, rest),
        React.createElement(LinkTextBox, null, linkify(payload.data.message, itMe))));
});
var HTMLMessageRow = memo(function (_a) {
    var payload = _a.payload, rest = __rest(_a, ["payload"]);
    return (React.createElement(AvatarBubble, __assign({}, rest),
        React.createElement(LinkTextBox, { dangerouslySetInnerHTML: { __html: payload.data.html || payload.data.message } })));
});
var SystemMessageRow = function (_a) {
    var payload = _a.payload; _a.startBlock; _a.endBlock;
    return React.createElement(SystemMessageStyled, null, payload.data.message);
};
var SelectButtonsBox = styled(Flex)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  justify-content: space-around;\n  flex-wrap: wrap;\n  height: ", ";\n  overflow: hidden;\n  transition: 0.2s;\n"], ["\n  justify-content: space-around;\n  flex-wrap: wrap;\n  height: ", ";\n  overflow: hidden;\n  transition: 0.2s;\n"])), function (_a) {
    var open = _a.open;
    return (open ? 'auto' : '0');
});
var SelectMessageRow = memo(function (_a) {
    var payload = _a.payload, itMe = _a.itMe, messages = _a.messages, sender = _a.sender, onSend = _a.onSend, rest = __rest(_a, ["payload", "itMe", "messages", "sender", "onSend"]);
    var _b = useState(false), sending = _b[0], setSending = _b[1];
    var myIndex = messages.findIndex(function (msg) { return msg.payload === payload; });
    var responses = messages.slice(myIndex).filter(function (msg) {
        if (msg.senderUserId === (sender === null || sender === void 0 ? void 0 : sender.id))
            return false;
        if (msg.payload.type === 'text') {
            return payload.data.options.map(function (opt) { return opt.name; }).includes(msg.payload.data.message);
        }
        return false;
    });
    var hasResponse = responses.length > 0;
    return (React.createElement(AvatarBubble, __assign({ itMe: itMe, sender: sender }, rest, { afterBubble: React.createElement(SelectButtonsBox, { m: "5px 0", open: !hasResponse }, payload.data.options.map(function (option) {
            return (React.createElement(SelectOptionWrapper, { key: option.name },
                React.createElement(Button, { isLoading: sending, key: option.name, text: option.name, size: "small", bordered: true, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, , 2, 3]);
                                    setSending(true);
                                    return [4 /*yield*/, onSend(option.name)];
                                case 1:
                                    _a.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    setSending(false);
                                    return [7 /*endfinally*/];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); } })));
        })) }),
        React.createElement(LinkTextBox, null, linkify(payload.data.prompt, itMe))));
});
var ModifyTripMessageRow = memo(function (_a) {
    var payload = _a.payload, itMe = _a.itMe, sender = _a.sender, rest = __rest(_a, ["payload", "itMe", "sender"]);
    return (React.createElement(AvatarBubble, __assign({ itMe: itMe, sender: sender }, rest, { afterBubble: itMe ? null : React.createElement(ModifyPayloadWrapper, null, payload.data.data.specialInstructions) }),
        React.createElement(LinkTextBox, null, linkify(payload.data.prompt, itMe))));
});
var templateObject_1$a, templateObject_2$4, templateObject_3$2, templateObject_4$2, templateObject_5$2, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11, templateObject_12, templateObject_13;

var MessageListContainer = styled(Flex)(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  height: 100%;\n  overflow-y: auto;\n  position: relative;\n  ::-webkit-scrollbar {\n    width: 0 !important;\n  }\n"], ["\n  height: 100%;\n  overflow-y: auto;\n  position: relative;\n  ::-webkit-scrollbar {\n    width: 0 !important;\n  }\n"])));
// The left padding is to make it respect the area for the avatars
var DateDivider = styled(Flex)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  height: 12px;\n  justify-content: ", ";\n  color: grey;\n  text-align: ", ";\n  font-size: 12px;\n  padding-left: 62px;\n  padding-right: ", ";\n  margin-bottom: 4px;\n"], ["\n  height: 12px;\n  justify-content: ", ";\n  color: grey;\n  text-align: ", ";\n  font-size: 12px;\n  padding-left: 62px;\n  padding-right: ", ";\n  margin-bottom: 4px;\n"])), function (_a) {
    var itMe = _a.itMe, doubleAgent = _a.doubleAgent;
    return (itMe || doubleAgent ? 'flex-end' : 'flex-start');
}, function (_a) {
    var itMe = _a.itMe, doubleAgent = _a.doubleAgent;
    return (itMe || doubleAgent ? 'right' : 'left');
}, function (_a) {
    var itMe = _a.itMe;
    return (itMe ? '4px' : '62px');
});
var getNormalizedDate = function (dateString) { return new Date(dateString.endsWith('Z') ? dateString : "".concat(dateString, "Z")); };
var HIDE_DATES = true;
var formattedDate = function (ds) {
    var date = parseDate("".concat(ds, "Z"));
    var today = new Date();
    var sameDay = date.getDate() === today.getDate() &&
        date.getFullYear() === today.getFullYear() &&
        date.getMonth() === today.getMonth();
    var dateStr;
    if (sameDay || HIDE_DATES) {
        dateStr = "".concat(hourMinuteMeridian(date));
    }
    else {
        dateStr = "".concat(hourMinuteMeridian(date), " | ").concat(dayOfWeekLongFormatter(date), ", ").concat(monthLongFormatter(date), " ").concat(dayOfMonthFormatter(date));
    }
    return dateStr;
};
function chonk(pred, lists) {
    var deep = lists.map(function (list) {
        return list.reduce(function (acc, item) {
            if (acc.length > 0) {
                var lastChonk = acc[acc.length - 1];
                if (lastChonk.length > 0) {
                    var prev = lastChonk[lastChonk.length - 1];
                    if (pred(prev, item)) {
                        lastChonk.push(item);
                        return acc;
                    }
                    return acc.concat([[item]]);
                }
                lastChonk.push(item);
                return acc;
            }
            return [[item]];
        }, []);
    });
    return [].concat.apply([], deep);
}
function makeChonker() {
    var preds = [];
    var process = function (list) {
        return preds.reduce(function (acc, pred) {
            return chonk(pred, acc);
        }, [list]);
    };
    process.chonk = function (pred) {
        preds.push(pred);
        return process;
    };
    return process;
}
var dateChonker = makeChonker().chonk(function (prev, next) {
    var p = getNormalizedDate(prev.created);
    var n = getNormalizedDate(next.created);
    return (p.getUTCFullYear() === n.getUTCFullYear() && p.getUTCMonth() === n.getUTCMonth() && p.getUTCDay() === n.getUTCDay());
});
var senderChonker = makeChonker().chonk(function (prev, next) { return prev.senderUserId === next.senderUserId; });
var GAP = 179000; // Just under 3 minutes
var timeGapChonker = makeChonker().chonk(function (prev, next) {
    var p = getNormalizedDate(prev.created);
    var n = getNormalizedDate(next.created);
    return n.getTime() - p.getTime() < GAP;
});
var ChatMessages = memo(function (_a) {
    var messages = _a.messages, onSeen = _a.onSeen, onSend = _a.onSend, users = _a.users, botName = _a.botName;
    var scroller = useRef();
    var me = useContext(ChatUserContext);
    var bottom = useRef();
    useEffect(function () {
        // right now we just confirm seen on all messages we get
        var seen = messages.filter(function (msg) { return !msg.seen; });
        if (seen.length > 0) {
            onSeen(seen);
            // If there were unseen messages, scroll the bottom of the messages into view to see them
            if (bottom.current) {
                bottom.current.scrollIntoView();
            }
        }
    }, [onSeen, messages]);
    return (React.createElement(MessageListContainer, { flexDirection: "column", ref: scroller },
        React.createElement(Box, { p: "12px 0 0 0" },
            dateChonker(messages).map(function (dayMsgs) {
                return (React.createElement(Fragment, { key: dayMsgs[0].created }, senderChonker(dayMsgs).map(function (senderBlock) {
                    return timeGapChonker(senderBlock).map(function (tightBlock) {
                        var last = tightBlock[tightBlock.length - 1];
                        var blockKey = tightBlock[0].senderUserId + tightBlock[0].id;
                        var sender = users[tightBlock[0].senderUserId];
                        var doubleAgent = me.isAgent && sender && sender.isAgent;
                        return (React.createElement(Fragment, { key: blockKey },
                            tightBlock.map(function (msg, i) {
                                return (React.createElement(MessageRow, { key: msg.id, onSend: onSend, message: msg, messages: messages, botName: botName, sender: sender, startBlock: i === 0, endBlock: i === tightBlock.length - 1 }));
                            }),
                            React.createElement(DateDivider, { key: blockKey, itMe: last.senderUserId === me.id, doubleAgent: doubleAgent }, formattedDate(last.created))));
                    });
                })));
            }),
            React.createElement("div", { ref: bottom }))));
});
var templateObject_1$9, templateObject_2$3;

var ChatFooter = styled(Flex)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  height: 28px;\n  border-top: 1px solid #ececec;\n  font-size: 13px;\n  color: gray;\n"], ["\n  justify-content: center;\n  align-items: center;\n  height: 28px;\n  border-top: 1px solid #ececec;\n  font-size: 13px;\n  color: gray;\n"])));
var templateObject_1$8;

var ChatContainer = styled(Flex)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  flex-direction: column;\n"], ["\n  flex-direction: column;\n"])));
var WebChat = function (_a) {
    var messages = _a.messages, onSend = _a.onSend, onSeen = _a.onSeen, user = _a.user, users = _a.users, botName = _a.botName, footer = _a.footer, readOnly = _a.readOnly;
    var wrappedSeen = useCallback(function (messages) {
        if (readOnly)
            return null;
        var seen = messages.filter(function (msg) { return msg.senderUserId !== user.id; });
        if (seen.length) {
            onSeen(seen);
        }
    }, [onSeen, readOnly]);
    return (React.createElement(ChatContainer, null,
        React.createElement(ChatUserContext.Provider, { value: user },
            React.createElement(ChatMessages, { messages: messages, onSeen: wrappedSeen, users: users || {}, onSend: onSend, botName: botName }),
            React.createElement(ChatFooter, null, footer ? footer(user) : null))));
};
var templateObject_1$7;

var ColoredSphere = styled(Flex)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  height: 50px;\n  background-color: ", ";\n  border-radius: 50px;\n  box-shadow: ", ";\n  cursor: pointer;\n"], ["\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  height: 50px;\n  background-color: ", ";\n  border-radius: 50px;\n  box-shadow: ", ";\n  cursor: pointer;\n"])), getThemeProp('chat.minimized-chat--color'), getTokenValue(THEME_TOKENS.base.shadow.raised));
var GraphicWrapper = styled(Box)(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  font-size: 30px;\n  color: ", ";\n  margin-top: 6px;\n  margin-left: -2px;\n"], ["\n  font-size: 30px;\n  color: ", ";\n  margin-top: 6px;\n  margin-left: -2px;\n"])), getThemeProp('chat.minimized-icon--color'));
var WebChatMinimized = function () {
    return (React.createElement(ColoredSphere, null,
        React.createElement(GraphicWrapper, null,
            React.createElement(IconChatRound, null))));
};
var templateObject_1$6, templateObject_2$2;

var PopoverCard = styled(Box)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  /* TODO: reslove padding issue in popover component? */\n  border-radius: 4px;\n  box-shadow: 0 0 20px 4px rgb(154 161 177 / 15%), 0 4px 80px -8px rgb(36 40 47 / 25%),\n    0 4px 4px -2px rgb(91 94 105 / 15%);\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  background-color: white;\n  color: black;\n"], ["\n  /* TODO: reslove padding issue in popover component? */\n  border-radius: 4px;\n  box-shadow: 0 0 20px 4px rgb(154 161 177 / 15%), 0 4px 80px -8px rgb(36 40 47 / 25%),\n    0 4px 4px -2px rgb(91 94 105 / 15%);\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  background-color: white;\n  color: black;\n"])));
var templateObject_1$5;

var Relative$1 = styled(Box)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var emojiPickerStyles = {
    width: 320,
    borderWidth: 0,
};
var EmojiSelector = (function (_a) {
    var onSelect = _a.onSelect, children = _a.children; _a.direction; __rest(_a, ["onSelect", "children", "direction"]);
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    var mySelect = function (emoji) {
        onSelect(emoji);
        setVisible(false);
    };
    return (React.createElement(Relative$1, null,
        React.createElement(Popover, { isOpen: visible, onClickOutside: function () { return setVisible(false); }, containerStyle: { zIndex: '9999' }, content: React.createElement(PopoverCard, null,
                React.createElement(Picker, { style: emojiPickerStyles, onSelect: mySelect, native: true, title: "Choose emoji", emoji: "point_up", sheetSize: 32 })) },
            React.createElement("span", { onClick: function () { return setVisible(!visible); } }, children))));
});
var EmojiInserter = memo((function (_a) {
    var onSelect = _a.onSelect, rest = __rest(_a, ["onSelect"]);
    return (React.createElement(EmojiSelector, __assign({ onSelect: function (emoji) { return onSelect(emoji.native); } }, rest, { appendTo: function () { return document.body; } }),
        React.createElement(ClickableGraphic, { style: { color: 'peru' }, icon: React.createElement(IconSmile, null), size: "large" })));
}));
var templateObject_1$4;

var GlobalStyle = createGlobalStyle(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  .emoji-mart-title-label {\n    font-size: 20px !important;\n  }\n"], ["\n  .emoji-mart-title-label {\n    font-size: 20px !important;\n  }\n"])));
var NiceInput = styled.textarea(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  resize: none;\n  padding: 8px;\n  width: calc(100% - 16px);\n  height: ", ";\n  min-height: unset;\n  border: 0;\n  outline: none;\n  font-family: ", ";\n  font-size: 15px;\n  background-color: white;\n  overflow-y: auto;\n\n  &::placeholder {\n    color: darkgrey;\n  }\n"], ["\n  resize: none;\n  padding: 8px;\n  width: calc(100% - 16px);\n  height: ", ";\n  min-height: unset;\n  border: 0;\n  outline: none;\n  font-family: ", ";\n  font-size: 15px;\n  background-color: white;\n  overflow-y: auto;\n\n  &::placeholder {\n    color: darkgrey;\n  }\n"])), function (_a) {
    var compact = _a.compact;
    return (compact ? '100px' : '135px');
}, getThemeProp('global.textBody--fontFamily'));
var Relative = styled(Box)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  background-color: white;\n"], ["\n  position: relative;\n  width: 100%;\n  background-color: white;\n"])));
var BottomRight = styled(Box)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  ", "\n  position: absolute;\n  bottom: 0px;\n  right: 5px;\n  font-size: 35px;\n  color: ", ";\n\n  @media (max-width: 768px) {\n    bottom: 7px;\n  }\n"], ["\n  ", "\n  position: absolute;\n  bottom: 0px;\n  right: 5px;\n  font-size: 35px;\n  color: ", ";\n\n  @media (max-width: 768px) {\n    bottom: 7px;\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '' : 'cursor: pointer;');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '#bbbbbb' : getThemeProp('global.dark--color'));
});
var TopRight = styled(Box)(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  top: -4px;\n  right: -2px;\n  font-size: 28px;\n  color: ", ";\n\n  @media (max-width: 768px) {\n    bottom: 7px;\n  }\n"], ["\n  cursor: pointer;\n  position: absolute;\n  top: -4px;\n  right: -2px;\n  font-size: 28px;\n  color: ", ";\n\n  @media (max-width: 768px) {\n    bottom: 7px;\n  }\n"])), getThemeProp('global.link--color'));
var lockout = (function (delay) {
    var locked = false;
    var timeoutHandle;
    return function (starter, ender) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!locked) {
                locked = true;
                starter();
            }
            if (timeoutHandle) {
                clearTimeout(timeoutHandle);
            }
            timeoutHandle = setTimeout(function () {
                locked = false;
                ender();
            }, delay);
            return [2 /*return*/];
        });
    }); };
})(2000);
var MessageInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, onSend = _a.onSend, onType = _a.onType, compact = _a.compact, disabled = _a.disabled, placeholder = _a.placeholder;
    var mySend = function (val) {
        if (disabled)
            return;
        onSend(val.trimRight());
    };
    var enterCheck = function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            mySend(value.trimRight());
        }
    };
    var myChange = useCallback(function (value) {
        onChange(value);
        lockout(function () { return onType(true); }, function () { return onType(false); });
    }, [onChange, lockout, onType]);
    var insertEmoji = useCallback(function (emoji) {
        onChange(function (val) { return val + emoji; });
    }, [onChange]);
    return (React.createElement(Relative, null,
        React.createElement(GlobalStyle, null),
        React.createElement(NiceInput, { placeholder: placeholder || 'Type a message', onKeyUp: enterCheck, onChange: function (e) { return myChange(e.currentTarget.value); }, value: value, compact: compact, disabled: disabled }),
        disabled ? null : (React.createElement(MatchMedia.Small, null,
            React.createElement(TopRight, null,
                React.createElement(EmojiInserter, { onSelect: insertEmoji })))),
        React.createElement(BottomRight, { disabled: disabled },
            React.createElement(Button, { iconLineName: "ArrowUp", onClick: function () { return mySend(value.trimRight()); }, round: true, size: "small" }))));
};
var templateObject_1$3, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1;

var ChatSystemLocation = styled(Box)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  position: fixed;\n  z-index: ", ";\n  bottom: 20px;\n  right: 20px;\n\n  @media (max-width: 768px) {\n    top: 5px;\n    bottom: 5px;\n    left: 5px;\n    right: 5px;\n  }\n"], ["\n  position: fixed;\n  z-index: ", ";\n  bottom: 20px;\n  right: 20px;\n\n  @media (max-width: 768px) {\n    top: 5px;\n    bottom: 5px;\n    left: 5px;\n    right: 5px;\n  }\n"])), ZINDEX.MODAL);
var ChatSystemLocationMini = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  z-index: ", ";\n  bottom: 15px;\n  right: 15px;\n"], ["\n  position: fixed;\n  z-index: ", ";\n  bottom: 15px;\n  right: 15px;\n"])), ZINDEX.MODAL);
var ChatBox = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-direction: column;\n  width: 350px;\n  border-radius: ", ";\n  overflow: hidden;\n  background: white;\n  box-shadow: ", ";\n  height: 500px;\n  font-size: 14px;\n\n  @media (max-width: 768px) {\n    width: 100%;\n    height: calc(100% - 5px);\n    border-radius: 0;\n  }\n"], ["\n  flex-direction: column;\n  width: 350px;\n  border-radius: ", ";\n  overflow: hidden;\n  background: white;\n  box-shadow: ", ";\n  height: 500px;\n  font-size: 14px;\n\n  @media (max-width: 768px) {\n    width: 100%;\n    height: calc(100% - 5px);\n    border-radius: 0;\n  }\n"])), getTokenValue(THEME_TOKENS.card.size.borderRadiusMedium), getTokenValue(THEME_TOKENS.base.shadow.raised));
var ChatHeader = styled(Flex)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  height: 40px;\n  padding: 8px;\n  color: black;\n  background-color: white;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  font-size: 16px;\n"], ["\n  position: relative;\n  height: 40px;\n  padding: 8px;\n  color: black;\n  background-color: white;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  font-size: 16px;\n"])), getTokenValue(THEME_TOKENS.card.color.border));
var WebChatWrapper = styled(Flex)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  height: 380px;\n  overflow: hidden;\n  flex-direction: column;\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n"], ["\n  height: 380px;\n  overflow: hidden;\n  flex-direction: column;\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n"])));
var MessagesWrapper = styled(Flex)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  // make room for the height of the header\n  height: calc(100% - 40px);\n"], ["\n  // make room for the height of the header\n  height: calc(100% - 40px);\n"])));
var MessageInputWrapper = styled(Box)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  overflow: hidden;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  margin: 0 12px 12px 12px;\n  flex: 0 0 auto;\n\n  &:has(textarea:focus) {\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  overflow: hidden;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  margin: 0 12px 12px 12px;\n  flex: 0 0 auto;\n\n  &:has(textarea:focus) {\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n"])), getTokenValue(THEME_TOKENS.textInput.color.border), getTokenValue(THEME_TOKENS.base.color.action), getTokenValue(THEME_TOKENS.textInput.shadow.focus));
styled(Box)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  height: 26px;\n  color: black;\n  font-size: 27px;\n  cursor: pointer;\n"], ["\n  height: 26px;\n  color: black;\n  font-size: 27px;\n  cursor: pointer;\n"])));
var ButtonsWrapper = styled(Flex)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  gap: 6px;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  gap: 6px;\n  justify-content: space-between;\n  align-items: center;\n"])));
var ClosedMessageContainer = styled(Box)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin: 16px;\n  padding: 16px;\n  line-height: 1.25;\n  flex: 0 0 auto;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", ";\n  color: ", ";\n"], ["\n  margin: 16px;\n  padding: 16px;\n  line-height: 1.25;\n  flex: 0 0 auto;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", ";\n  color: ", ";\n"])), getThemeProp('global.border--color'), getTokenValue(THEME_TOKENS.card.size.borderRadiusSmall), getTokenValue(THEME_TOKENS.base.color.primaryText));
var templateObject_1$2, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

var endedMessages = {
    ClosedByInactivity: 'Thank you for contacting us. Sorry, your chat session ended due to inactivity. If you still need help, please start a new chat.',
    ClosedByAnAgent: 'Thank you for contacting us and giving us the opportunity to serve you. If you still need help, please start a new chat.',
    ClosedByChatBot: 'Thank you for contacting us and giving us the opportunity to serve you. If you still need help, please start a new chat.',
    ClosedAfterMessageLeft: 'Thank you for leaving a message. A travel advisor will email you back as soon as possible. If you still need help, please start a new chat.',
    ClosedByChatBotAutomation: 'Thank you for contacting us and giving us the opportunity to serve you. If you still need help, please start a new chat.',
    Unknown: 'Thank you for contacting us. Sorry, your chat session ended. If you still need help, please start a new chat.',
};
var ClosedMessage = function (_a) {
    var user = _a.user, session = _a.session, onRestart = _a.onRestart;
    var surveyUrl = "/survey?type=PostChat&nameNum=".concat(user.nameNum, "&surveyId=2&context1=").concat(session.id, "&context2=").concat(session.agentUserId);
    var closedMessage = endedMessages[session.closeReason] || endedMessages.Unknown;
    return (React.createElement(ClosedMessageContainer, null,
        closedMessage,
        React.createElement("br", null),
        React.createElement(Box, { mt: 2 },
            React.createElement("a", { href: surveyUrl, target: "_blank", rel: "noreferrer" }, "Please tell us how we did today.")),
        onRestart ? (React.createElement(Box, { mt: 2 },
            React.createElement("a", { onClick: onRestart, target: "_blank", rel: "noreferrer" }, "Start a new chat."))) : null));
};
function selectNeedsResponse(messages, me) {
    var last = messages[messages.length - 1];
    if (last) {
        return last.payload.type === 'select' && last.senderUserId !== me.id;
    }
    return false;
}
var SessionChat = function (_a) {
    var messages = _a.messages, onSend = _a.onSend, onSeen = _a.onSeen, onType = _a.onType, botName = _a.botName, user = _a.user, users = _a.users, onClose = _a.onClose, onRestart = _a.onRestart, session = _a.session, setMini = _a.setMini;
    var agentName = users[session.agentUserId] ? users[session.agentUserId].clientName : 'Amtrav';
    var agentFirstName = agentName.split(' ')[0];
    var needsResponse = selectNeedsResponse(messages, user);
    var _b = useState(''), msg = _b[0], setMsg = _b[1];
    var sendAndClear = function (text) { return __awaiter(void 0, void 0, void 0, function () {
        var rollbackText, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rollbackText = text;
                    response = onSend(text);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setMsg('');
                    return [4 /*yield*/, response];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setMsg(rollbackText);
                    console.warn('Error in sending message: ', err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, response];
            }
        });
    }); };
    return (React.createElement(ChatBox, null,
        React.createElement(WebChatWrapper, null,
            React.createElement(ChatHeader, null,
                React.createElement("b", null, "Live Chat"),
                ' ',
                React.createElement(ButtonsWrapper, null,
                    React.createElement(Button, { borderedLight: true, iconLineName: "Minus", onClick: function () { return setMini(true); }, round: true, size: "small" }),
                    React.createElement(Button, { borderedLight: true, iconLineName: "X", onClick: onClose, round: true, size: "small" }))),
            React.createElement(MessagesWrapper, null,
                React.createElement(WebChat, { footer: function () { return React.createElement("span", null, session.agentTyping ? "".concat(agentFirstName, " is typing...") : null); }, readOnly: session.closed, messages: messages, onSend: onSend, onSeen: onSeen, user: user, users: users, botName: botName }))),
        session.closed ? React.createElement(ClosedMessage, { user: user, session: session, onRestart: onRestart }) : null,
        !session.closed ? (React.createElement(MessageInputWrapper, null,
            React.createElement(MessageInput, { value: msg, onChange: setMsg, onSend: sendAndClear, onType: onType, disabled: needsResponse, placeholder: needsResponse ? 'Please click one of the buttons above' : null, compact: true }))) : null));
};

var WelcomeOpening$1 = styled(Box)(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"])));
var WelcomeChat = function (_a) {
    var 
    // unavailable,
    onClose = _a.onClose, onSend = _a.onSend, setMini = _a.setMini, user = _a.user, rest = __rest(_a, ["onClose", "onSend", "setMini", "user"]);
    var _b = useState(''), msg = _b[0], setMsg = _b[1];
    var sendAndClear = function (text) { return __awaiter(void 0, void 0, void 0, function () {
        var rollbackText, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rollbackText = text;
                    response = onSend(text);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setMsg('');
                    return [4 /*yield*/, response];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setMsg(rollbackText);
                    console.warn('Error in sending message: ', err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, response];
            }
        });
    }); };
    var isLoggedInUser = user.nameNum !== 0;
    var getWelcomeGreeting = function (userName) {
        function getRandomItem(list) {
            return list[Math.floor(Math.random() * list.length)];
        }
        var kbLink = (React.createElement("a", { target: "_blank", href: "https://www.amtrav.com/knowledgebase", rel: "noreferrer" }, "Knowledge Base"));
        var welcomeGreetingRegisteredUser = [
            "Hi ".concat(userName, "."),
            "Hello ".concat(userName, "."),
            "Hey ".concat(userName, "."),
            "Good day ".concat(userName, "."),
            "Greetings ".concat(userName, "."),
            "How are you ".concat(userName, "."),
            "Good to see you ".concat(userName, "."),
            "Nice to see you ".concat(userName, "."),
        ];
        var welcomeGreetingsUnknownUser = [
            'Hi there.',
            'Hello there.',
            'Hey there.',
            'Good day.',
            'Greetings.',
            'Nice to see you here.',
        ];
        var howToHelpGreetings = [
            'How can we help you?',
            'How may we help you?',
            'How can we be of assistance?',
            'How may we be of assistance?',
            'How may we assist you?',
            'How can we assist you?',
            'What can we help you with?',
            'Please tell us how we can help',
        ];
        var kbLinkPrompts = [
            React.createElement(React.Fragment, null,
                "Check out our ",
                kbLink,
                " for common questions."),
            React.createElement(React.Fragment, null,
                "You may also check our ",
                kbLink,
                " to see if your question is addressed there."),
        ];
        return (React.createElement(React.Fragment, null,
            React.createElement(WelcomeOpening$1, null, userName
                ? "".concat(getRandomItem(welcomeGreetingRegisteredUser), " ").concat(getRandomItem(howToHelpGreetings))
                : "".concat(getRandomItem(welcomeGreetingsUnknownUser), " ").concat(getRandomItem(howToHelpGreetings))),
            React.createElement(Box, { pt: 2 }, getRandomItem(kbLinkPrompts))));
    };
    var welcomeGreeting = useMemo(function () { return (React.createElement(ClosedMessageContainer, null, getWelcomeGreeting(isLoggedInUser ? user.clientName : null))); }, []);
    var WelcomeWindow = (React.createElement(React.Fragment, null,
        React.createElement(WebChatWrapper, null,
            React.createElement(ChatHeader, null,
                React.createElement("b", null, "Live Chat"),
                ' ',
                React.createElement(ButtonsWrapper, null,
                    React.createElement(Button, { borderedLight: true, iconLineName: "Minus", onClick: function () { return setMini(true); }, round: true, size: "small" }),
                    React.createElement(Button, { borderedLight: true, iconLineName: "X", onClick: onClose, round: true, size: "small" }))),
            welcomeGreeting),
        React.createElement(MessageInputWrapper, null,
            React.createElement(MessageInput, __assign({ value: msg, onChange: setMsg, onSend: sendAndClear, onType: function () { } }, rest, { compact: true })))));
    return React.createElement(ChatBox, null, WelcomeWindow);
};
var templateObject_1$1;

var WelcomeOpening = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"])));
var ErrorChat = function (_a) {
    var onClose = _a.onClose, setMini = _a.setMini, errorMessage = _a.errorMessage;
    var WelcomeWindow = (React.createElement(WebChatWrapper, null,
        React.createElement(ChatHeader, null,
            React.createElement("b", null, "Live Chat"),
            ' ',
            React.createElement(ButtonsWrapper, null,
                React.createElement(Button, { borderedLight: true, iconLineName: "Minus", onClick: function () { return setMini(true); }, round: true, size: "small" }),
                React.createElement(Button, { borderedLight: true, iconLineName: "X", onClick: onClose, round: true, size: "small" }))),
        React.createElement(ClosedMessageContainer, null,
            React.createElement(WelcomeOpening, null, errorMessage))));
    return React.createElement(ChatBox, null, WelcomeWindow);
};
var templateObject_1;

// this was previously the logged out "side tab" chat launcher
// it now uses the same UI as the minimized state
var OpenButton = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(ChatSystemLocationMini, { onClick: onClick },
        React.createElement(WebChatMinimized, null)));
};
var Minimizer = function (_a) {
    var mini = _a.mini, maximize = _a.maximize, children = _a.children;
    return mini ? (React.createElement(ChatSystemLocationMini, { onClick: maximize },
        React.createElement(WebChatMinimized, null))) : (React.createElement(React.Fragment, null, children));
};
var ChatWindow = function (_a) {
    var onSend = _a.onSend, session = _a.session, errorMessage = _a.errorMessage, rest = __rest(_a, ["onSend", "session", "errorMessage"]);
    var _b = useState(false), mini = _b[0], setMini = _b[1];
    return (React.createElement(Minimizer, { mini: mini, maximize: function () { return setMini(false); } },
        React.createElement(ChatSystemLocation, null, errorMessage ? (React.createElement(ErrorChat, { setMini: setMini, errorMessage: errorMessage, onClose: rest.onClose })) : session ? (React.createElement(SessionChat, __assign({ setMini: setMini, session: session, onSend: onSend }, rest))) : (React.createElement(WelcomeChat, __assign({ setMini: setMini, onSend: onSend, session: session }, rest))))));
};
var WebChatLauncher = function (_a) {
    var open = _a.open, rest = __rest(_a, ["open"]);
    // Render components
    return open ? React.createElement(ChatWindow, __assign({}, rest)) : React.createElement("div", null);
};

export { EmojiInserter, EmojiSelector, MessageInput, OpenButton, WebChat, WebChatLauncher, WebChatMinimized };
//# sourceMappingURL=index.js.map
